<div id="check-links-loading" *ngIf="loading">
    <i class="fas fa-spinner fa-spin me-2"></i>
    <span>Cargando...</span>
</div>

<div id="check-links-error" class="text-danger" *ngIf="!loading && error">
    <i class="fa fa-times me-2"></i>
    <span>Error</span>
</div>

<div id="links-empty" *ngIf="!loading && !error && links.length == 0">
    <p>No hay enlaces en este curso.</p>
</div>

<div id="check-links" *ngIf="!loading && !error && links.length > 0">

    <table id="links-table">
        <thead>
            <tr>
                <th>Enlace</th>
                <th>Enunciado</th>
                <th>UA / Lección</th>
                <th>Estado</th>
                <!-- <th>Ver</th> -->
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let link of links;">
                <td [innerHtml]="link.link"></td>
                <td>{{ link.heading.name }}</td>
                <td>UA{{ link.unit_num }} L{{ link.lesson_num }}</td>
                <td *ngIf="!link.checked">
                    <i class="fas fa-spinner fa-spin"></i>
                    <span>Revisando...</span>
                </td>
                <td class="text-danger" *ngIf="link.checked && !link.valid">
                    <i class="fas fa-times"></i>
                    <span>No válido</span>
                </td>
                <td class="text-success" *ngIf="link.checked && link.valid">
                    <i class="fas fa-check"></i>
                    <span>Válido</span>
                </td>
                <!--
                <td>
                    <a href="#" (click)="showHeading(link.heading.id, link.link)">
                        <i class="fas fa-eye"></i>
                        <span>Ver</span>
                    </a>
                </td>
                -->
            </tr>
        </tbody>
    </table>

    <dialog id="link-heading-dialog">
        <h4></h4>
        <p>
            <i class="fas fa-spinner fa-spin"></i>
            <span>Cargando...</span>
        </p>
    </dialog>

</div>